export default "__VITE_ASSET__CpyHhzd0__"